import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { PERMISSION } from "../lib/permissions";
import {
  selectCurrentUserId,
  selectIsSuperAdmin,
  selectPermissionLookup,
  selectProfile,
} from "../redux/auth/selectors";

export const usePermissions = () => {
  const isSuperAdmin = useSelector(selectIsSuperAdmin);
  const currentUserId = useSelector(selectCurrentUserId);
  const profile = useSelector(selectProfile);
  const lookup = useSelector(selectPermissionLookup);

  const hasAction = useCallback(
    (menuId, action = PERMISSION.VIEW) => {
      if (isSuperAdmin) return true;
      const set = lookup.get(Number(menuId));
      return set ? set.has(action) : false;
    },
    [isSuperAdmin, lookup],
  );

  const hasMenuAccess = useCallback(
    (menuId) => hasAction(menuId, PERMISSION.VIEW),
    [hasAction],
  );

  const hasAnyAction = useCallback(
    (menuId, actions) => actions.some((a) => hasAction(menuId, a)),
    [hasAction],
  );

  return useMemo(
    () => ({
      profile,
      currentUserId,
      isSuperAdmin,
      hasAction,
      hasMenuAccess,
      hasAnyAction,
    }),
    [profile, currentUserId, isSuperAdmin, hasAction, hasMenuAccess, hasAnyAction],
  );
};
